function IconTwitterComponent() {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88101 20C9.72393 20.0126 11.551 19.6591 13.2561 18.9598C14.9613 18.2605 16.5105 17.2294 17.8139 15.9265C19.1173 14.6236 20.1489 13.0747 20.8488 11.3698C21.5487 9.6649 21.903 7.83795 21.891 5.99503C21.891 5.78203 21.891 5.57003 21.877 5.35803C22.8409 4.65935 23.6726 3.7945 24.333 2.80403C23.4344 3.20231 22.4811 3.46355 21.505 3.57903C22.5331 2.96358 23.3025 1.9955 23.67 0.855027C22.7037 1.43032 21.6461 1.83617 20.543 2.05503C19.8008 1.26662 18.8196 0.744597 17.7511 0.569643C16.6825 0.394688 15.586 0.57654 14.6312 1.08709C13.6763 1.59765 12.9162 2.40848 12.4682 3.39428C12.0203 4.38008 11.9095 5.48596 12.153 6.54103C10.1949 6.443 8.27931 5.93419 6.53066 5.04763C4.782 4.16107 3.23939 2.91659 2.00301 1.39503C1.3729 2.47928 1.17985 3.76297 1.4632 4.98458C1.74654 6.2062 2.48495 7.27385 3.52801 7.97003C2.74608 7.94618 1.98131 7.73492 1.29801 7.35403C1.29801 7.37503 1.29801 7.39503 1.29801 7.41703C1.29832 8.55383 1.69181 9.65554 2.41174 10.5353C3.13168 11.4151 4.13374 12.0188 5.24801 12.244C4.52284 12.4416 3.76202 12.4704 3.02401 12.328C3.33861 13.3064 3.95112 14.1621 4.77589 14.7753C5.60066 15.3885 6.59645 15.7286 7.62401 15.748C5.87967 17.1171 3.72547 17.8596 1.50801 17.856C1.11535 17.8564 0.723007 17.8337 0.333008 17.788C2.58452 19.2346 5.20484 20.0025 7.88101 20Z"
        fill="white"
      />
    </svg>
  );
}

export { IconTwitterComponent };
